import React from 'react';

import useGlobalStore from '../../../../shared/store/globalStore';

import UserAvatar from '../../../../shared/components/UserAvatar';
import TitlePage from '../../../../shared/components/TitlePage';
import { Text } from '../../../../shared/components/Text';

export default function UserInfo() {
  const user = useGlobalStore((state) => state.general.user);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
      }}
    >
      <UserAvatar width={70} height={70} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start', // This is a little strange... Maybe review in the future
          alignItems: 'flex-start',
          boxSizing: 'border-box',
          marginLeft: '10px',
        }}
      >
        <TitlePage
          label={
            user?.firstName
              ? `Bem Vindo(a), ${user.firstName}!`
              : `Bem Vindo(a)!`
          }
          margin={0}
        />
        <Text.normal weak>Esperamos que tenha um dia excelente!</Text.normal>
      </div>
    </div>
  );
}
